import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import NavHeader from './Navbar/NavHeader.js';
import NavContent from './Navbar/NavContent.js';
import NavSignedOut from './Navbar/NavSignedOut.js';

class SignedOut extends Component {

  render() {
    return (
      <Navbar staticTop collapseOnSelect>
        <NavHeader />
        <NavContent right={<NavSignedOut />} />
      </Navbar>
    );
  }

}

export default SignedOut;



// WEBPACK FOOTER //
// ./src/components/SignedOutNav.js